export enum ERiskCategory {
  A = 'A',
  B = 'B',
  C = 'C',
  D = 'D',
}
